import { ColDef } from "ag-grid-community";

export interface ContentBlockRecord {
  ContentBlockId: number | string;
  BlockName: string;
  BlockData: string;
  Status?: string;
  Active?: "Y" | "N";
  CreatedDate?: string;
  Operation?: string;
  FilePath?: string;
  Instructions?: string;
}

export interface FetchContentBlocksResponse {
  data: ContentBlockRecord[];
}

export type ModelMode = "create" | "edit" | "view";


/**
 * Get default column definition for AG Grid
 * @returns Default column definition
 */
export const getDefaultColDef = (): ColDef => ({
  sortable: true,
  filter: true,
  resizable: true,
});

/**
 * Get no rows overlay component params
 * @param refreshGrid Whether the grid is refreshing
 * @returns No rows overlay component params object
 */
export const getNoRowsOverlayParams = (refreshGrid: boolean) => ({
  noRowsMessageFunc: () => !refreshGrid ? `No data available` : `Loading your content blocks`
});


/**
 * Get grid style configuration
 * @returns Grid style object
 */
export const getGridStyle = () => ({ 
  height: "85vh", 
  width: "100%" 
});

